
import { defineComponent, onMounted, ref } from 'vue'
import TigerMachineLottery from './TigerMachineLottery.vue'

export default defineComponent({
  components: { TigerMachineLottery },
  setup () {
    const lottery = ref(0)
    const lotterySwitch = ref(true)

    function lotteryRandom () {
      if (lotterySwitch.value) return

      const result = Math.ceil(Math.random() * 5)

      if (lottery.value !== result) {
        lotterySwitch.value = true

        lottery.value = result

        return
      }
      lotteryRandom()
    }

    function closeLotterySwitch () {
      console.log('closeLotterySwitch')

      lotterySwitch.value = false
    }

    onMounted(() => {
      lottery.value = 1
    })

    return {
      lottery,
      lotteryRandom,
      lotterySwitch,
      closeLotterySwitch
    }
  }
})
